import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Table from './Table';
import { parse } from 'query-string';
import useRouter from '@/hooks/useRouter';
import initialColumns from './columns';
import { useConnect } from '@lore/query-connect';
import { PayloadStates } from '@lore/utils';
import Loader from '@/components/Loader';
import _ from 'lodash';

export default function Team(props) {
  const { network } = props;

  const { location } = useRouter();

  const PAGE_SIZE = 20;

  const [columns] = useState(initialColumns);

  const selectedColumns = columns.filter(column => column.selected);

  const networkStewards = useConnect('networkSteward.find', {
    where: {
      eager: {
        $where: {
          networkId: network.id
        },
        $eager: {
          user: {}
        }
      }
    },
    pagination: {
      page: parse(location.search).page || '1',
      pageSize: PAGE_SIZE,
      order: 'createdAt desc',
    }
  });

  const stewardInvitations = useConnect('stewardInvitation.find', {
    where: {
      eager: {
        $where: {
          networkId: network.id
        }
      }
    },
    pagination: {
      page: parse(location.search).page || '1',
      pageSize: PAGE_SIZE,
      order: 'createdAt desc',
    }
  });

  if (
    networkStewards.state === PayloadStates.FETCHING ||
    stewardInvitations.state === PayloadStates.FETCHING
  ) {
    return (
      <Loader />
    );
  }

  const stewardMap = {};

  networkStewards.data.forEach(function(networkSteward) {
    const email = networkSteward.data._eager.user.email;
    stewardMap[email] = stewardMap[email] || {};
    stewardMap[email].id = `steward-${networkSteward.data.id}`;
    stewardMap[email].networkSteward = networkSteward;
    stewardMap[email].user = networkSteward.data._eager.user;
  });

  stewardInvitations.data.forEach(function(stewardInvitation) {
    const email = stewardInvitation.data.email;
    stewardMap[email] = stewardMap[email] || {};
    if(!stewardMap[email].id)
      stewardMap[email].id = `invitation-${stewardInvitation.data.id}`;
    stewardMap[email].stewardInvitation = stewardInvitation;
    stewardMap[email].user = stewardMap[email].user || stewardInvitation.data.user;
  });

  const stewards = _.reduce(stewardMap, function(result, value, _key) {
    result.push(value);
    return result;
  }, []);

  return (
    <Table
      pageSize={PAGE_SIZE * 2}
      columns={selectedColumns}
      select={function (_getState) {
        return {
          state: PayloadStates.RESOLVED,
          data: stewards,
          meta: {
            totalCount: (_.get(networkStewards, 'meta.totalCount', 0)) + (_.get(stewardInvitations, 'meta.totalCount', 0)),
            stewardCount: _.get(networkStewards, 'meta.totalCount', 0),
            stewardInvitationCount: _.get(stewardInvitations, 'meta.totalCount', 0),
            stewardInvitations: stewardInvitations.data.length,
            stewards: networkStewards.data.length,
          }
        };
      }}
      row={function (data) {
        return (
          <tr key={data.id}>
            {/*<pre>{index}-{JSON.stringify(data.id)}</pre>*/}
            {selectedColumns.map(function (column) {
              if (!column.row) {
                return null;
              }

              return (
                <column.row
                  key={column.id}
                  {...data}
                />
              );
            })}
          </tr>
        );
      }}
    />
  );
}

Team.propTypes = {
  network: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
  }).isRequired
};
